import areIntlLocalesSupported from "intl-locales-supported";
import Moment from "moment";
import "moment-precise-range-plugin";

const IntlPolyfill = require("intl");
require("intl/locale-data/jsonp/es");
require("intl/locale-data/jsonp/es-CL");

export const formatDateForFilter = (dateString) => {
  try {
    return Moment(dateString).format("YYYYMMDD");
  } catch (error) {
    console.log(error);
  }
};

export const formatDateForFormDenuncia = (dateString) => {
  try {
    return Moment(dateString).format("DD-MM-YYYY");
  } catch (error) {
    console.log(error);
  }
};

export const formatTimeForFormDenuncia = (dateString) => {
  try {
    return Moment(dateString).format("hh:mm");
  } catch (error) {
    console.log(error);
  }
};

export const calculateAge = (dateString) => {
  try {
    return `${Moment(dateString).diff(Moment(), "years") * -1}`;
  } catch (error) {
    console.log(error);
  }
};

export const calculateAgeDays = (dateString) => {
  try {
    let text = "";
    const diff = Moment.preciseDiff(dateString, Moment(), true);
    if (diff.years > 0) {
      return `${diff.years} ${diff.years === 1 ? 'Año' : 'Años'}`
    } else if (diff.months > 0) {
      return `${diff.months} ${diff.months === 1 ? 'Mes' : 'Meses'}`
    } else if (diff.days > 0) {
      return `${diff.days} ${diff.days === 1 ? 'Día' : 'Días'}`
    }
    return text;
  } catch (error) {
    console.error("calculateAgeDays", error);
  }
};

const customDateTimeFormat = {
  cl: () => {
    if (areIntlLocalesSupported(["es", "es-CL"])) {
      return global.Intl.DateTimeFormat;
    }
    return IntlPolyfill.DateTimeFormat;
  },
};

export default customDateTimeFormat;
